<template>
  <div>
      <MainMenu v-if="!isOnlyOrderProgressWindow"/>
      <el-breadcrumb separator="" style="top: 10px; position: relative; background-color: #eee; padding: 5px; border-radius: 25px;">
            
        <el-breadcrumb-item 
          v-for="(data, index) in $store.getters.getBreadcrumbs"
          :key="index">
          <span style=" color: #383838; font-size: 14px;">
            {{ data.crumbName}}
          </span>
        </el-breadcrumb-item>
        <div style="text-align: right; padding-right: 5px; padding-top: 0px; ">
        <a 
            v-if="$store.getters.getAccessRights.id>0 && !isOnlyOrderProgressWindow" 
            @click="saveBookmark"
            href="javascript:void(0)" 
            style="color: red;"><i 
              :class="isBookmarked ? 'el-icon-star-on' : 'el-icon-star-off'"></i> Bookmark{{isBookmarked ? 'ed' : ''}}</a>
        <a 
            v-if="isOnlyOrderProgressWindow"
            @click="toggleFullScreen"
            href="javascript:void(0)" 
            style="font-weight: bold; color: black;"><i class="el-icon-full-screen"></i></a>
        <a 
            v-if="isOnlyOrderProgressWindow"
            @click="logout"
            href="javascript:void(0)" 
            style="font-weight: bold; color: black; margin-left: 10px;">Logout</a>
        
      </div>
      </el-breadcrumb>
      <br><br>
    
  </div>
</template>

<script>
import MainMenu from './MainMenu.vue'

export default {
    components: {MainMenu},
    computed: {
      isBookmarked() {
        return this.$store.getters.getBookmarkList.findIndex(t => t.page_id === this.$store.getters.getAccessRights.id) >=0
      },
      isOnlyOrderProgressWindow() {
        const menuList = this.$store.getters.getAccessibleMenu

        let status = false

        if(menuList.length === 1) {
          menuList.forEach(element => {
              element.sub_menu.forEach(element1 => {
                  if(element1.menu_name.includes('Order Progress')) {
                    status = true
                  }
              })
          })
        }
        return status
      }
    },
    methods: {
      logout() {
        this.$confirm('Are you sure to logout?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
        }).then(() => {
            this.$store.dispatch('logout')
        }).catch(() => {
                   
        });
      },
      initiateCopy() {
        this.$store.dispatch('copyInformation', this.$store.getters.getMachineId)
      },
      openHelpSite() {
        window.open('https://reachus.easytailorapp.com')
      },
      goToHome() {
        this.$store.state.master.breadcrumbs = [{icon: 'el-icon-s-home', target: '/'}]
        this.$router.push('/')
      },
      saveBookmark() {
        this.$store.dispatch('saveBookmark', {page_id: this.$store.getters.getAccessRights.id})
      },
      toggleFullScreen() {
        const elem = document.documentElement
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
          elem.msRequestFullscreen();
        }
      }

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Header.vue